export class ConsumptionReportRequest{

    saleOrderId?:number;
    itemId?:number;
    consumedFromDate?:any;
    consumedToDate?:any;
    unitId?:number;
    itemCategoryId?:number;
    itemSubCategoryId?:string;
    uomId?:number;
    indentFromDate?:string
    indentToDate?:string
    createdFromDate?:string
    createdToDate?:string
    departmentId?:number


    constructor(saleOrderId?: number, itemId?:number,consumedFromDate?:any,consumedToDate?:any,unitId?:number,itemCategoryId?:number,itemSubCategoryId?:string, uomId?:number,indentFromDate?:string,
        indentToDate?:string,
        createdFromDate?:string,
        createdToDate?:string,departmentId?:number
    ) {
        this.saleOrderId = saleOrderId;
        this.itemId=itemId;
        this.consumedFromDate=consumedFromDate;
        this.consumedToDate=consumedToDate;
        this.unitId=unitId;
        this.itemCategoryId=itemCategoryId;
        this.itemSubCategoryId=itemSubCategoryId;
        this.uomId=uomId;
        this.indentFromDate = indentFromDate
        this.indentToDate = indentToDate
        this.createdFromDate = createdFromDate
        this.createdToDate = createdToDate
        this.departmentId=departmentId
    }
}